export const EDITOR_MAX_STORAGE_MB = 500;
export const EDITOR_MAX_STORAGE_BYTES = EDITOR_MAX_STORAGE_MB * 1024 * 1024;

/** 변환 VSE의 billed storage 계산에 적용하는 배수 (UI 표시 + 용량 판정 공통) */
export const VSE_STORAGE_BILLED_MULTIPLIER = 2;

export function billedVseStorageBytes(actualBytes: number): number {
  const n = Number(actualBytes);
  if (!Number.isFinite(n) || n <= 0) {
    return 0;
  }
  return Math.floor(n) * VSE_STORAGE_BILLED_MULTIPLIER;
}
